export default "__VITE_ASSET__DoiGN0ob__"